var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "绑定企业微信",
        visible: _vm.dialogVisible,
        width: "560px",
        "append-to-body": "",
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        opened: _vm.createLoginPanel,
        close: _vm.destroyLoginPanel,
      },
    },
    [
      _c("div", { staticClass: "bind-wecom__tip" }, [
        _vm._v("请点击 "),
        _c("span", { staticStyle: { color: "red" } }, [
          _vm._v("「继续在浏览器中登录访问」"),
        ]),
        _vm._v(" 完成绑定"),
      ]),
      _c("div", { ref: "loginPanel", staticClass: "bind-wecom__panel" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }